import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { signOutUser } from '../../../services/authService';
import FavoritesModal from '../../FavoritesModal';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isFavoritesModalOpen, setIsFavoritesModalOpen] = useState(false);

  const handleStockSelect = (symbol) => {
    // Navigate to dashboard with the selected stock
    navigate(`/dashboard?symbol=${encodeURIComponent(symbol)}`);
  };

  const menuItems = [
    {
      path: '/dashboard',
      icon: '📊',
      label: 'Dashboard',
      description: 'Market overview'
    },
    {
      path: '/analysis',
      icon: '📈',
      label: 'Analysis',
      description: 'Stock analysis'
    },
    {
      path: '/chat',
      icon: '🤖',
      label: 'AI Chat',
      description: 'AI-powered insights'
    },
    {
      path: '/company-reports',
      icon: '🏢',
      label: 'Company Reports',
      description: 'Financial reports & analysis'
    },
    {
      path: '/news-analysis',
      icon: '📰',
      label: 'News Analysis',
      description: 'News impact & sentiment'
    }
  ];

  const isActive = (path) => {
    // Handle both / and /dashboard as active for dashboard
    if (path === '/dashboard') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
    return location.pathname === path;
  };

  const handleLogout = async () => {
    try {
      await signOutUser();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-content">
        <div className="sidebar-header">
          <h3 className="sidebar-title">Navigation</h3>
        </div>
        
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar-item ${isActive(item.path) ? 'active' : ''}`}
            >
              <span className="sidebar-icon">{item.icon}</span>
              <div className="sidebar-item-content">
                <span className="sidebar-label">{item.label}</span>
                <span className="sidebar-description">{item.description}</span>
              </div>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-section">
            <h4 className="sidebar-section-title">Quick Actions</h4>
            <div className="quick-actions">
              <button 
                className="quick-action-btn"
                onClick={() => setIsFavoritesModalOpen(true)}
              >
                <span>⭐</span>
                <span>Favorites</span>
              </button>
              <div className="user-profile">
                <div className="user-info">
                  <span className="user-avatar">👤</span>
                  <span className="user-name">
                    {user ? (user.displayName || user.email || 'User') : 'Guest User'}
                  </span>
                </div>
                {user ? (
                  <button 
                    onClick={handleLogout} 
                    className="logout-btn"
                    title="Click to logout"
                  >
                    Logout
                  </button>
                ) : (
                  <button 
                    onClick={() => navigate('/login')} 
                    className="login-btn"
                    title="Click to login"
                  >
                    Login
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Favorites Modal */}
                <FavoritesModal 
          isOpen={isFavoritesModalOpen} 
          onClose={() => setIsFavoritesModalOpen(false)}
          onSelectStock={handleStockSelect}
        />
      </div>
    </aside>
  );
};

export default Sidebar; 